import {defineRecipe} from '@chakra-ui/react'
export const containerTheme = defineRecipe({base: {maxWidth: 'container.xl'}})
